import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Context } from "../../../contexts/Store";

export default function PrivateRoute({ children }) {
    const location = useLocation();
    const { state } = useContext(Context);
    const auth = state.user_details?.is_verified;

    if (auth) return children;
    const next = location.pathname !== "/" ? location.pathname : "";
    const to = next ? `/?auth=login&next=${encodeURIComponent(next)}` : "/?auth=login";
    return <Navigate to={to} replace />;
}
